import Container from './StudioPagination.container';
import Pagination from './StudioPagination';

export default Container(Pagination);
